import { render, staticRenderFns } from "./ReviewsPrivateFeedback.vue?vue&type=template&id=017d8e7d&scoped=true"
import script from "./ReviewsPrivateFeedback.vue?vue&type=script&lang=js"
export * from "./ReviewsPrivateFeedback.vue?vue&type=script&lang=js"
import style0 from "./ReviewsPrivateFeedback.vue?vue&type=style&index=0&id=017d8e7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017d8e7d",
  null
  
)

export default component.exports